module.exports = __webpack_public_path__ + "static/img/产品截图_image@2x.5c383b87.png";